<div class="app__container container-fluid">
  <div class="row app__background">
    <div class="container px-vertical-center">
        <div class="row">
            <div class="col-12 text-center">
                <a routerLink="/" [ngClass]="{'app__isDisabled': this.router.url === '/thanks'}">
                    <img src="/assets/logo_claim.svg"   style="min-height: 70px;" class="app__logo img-fluid" />
                </a>
            </div>

            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <h1 class="text-center white">Spendenaktion 2025 - Ihre Stimme ist gefragt!</h1>
                        <p class="text-center white">Sie entscheiden, welches Hilfsprojekt wir unterstützen. Erhöhen Sie mit
                            Ihrem Klick unsere Spende!</p>
                    </div>
                </div>
                <section class="start__cards">
                    <div class="row">
                        <div class="col-12 col-lg-4">
                            <div class="card">
                                <div class="card__image">
                                    <img class="img-fluid mw-80 w-aog" src="/assets/aerzte-ohne-grenzen.png" />
                                </div>
                                <div>
                                    <button class="button"
                                        *ngIf="firebaseService.voucherValid && firebaseService.voucherUsed === false"
                                        (click)="donate(DonationTarget.aerzteOhneGrenzen)">Spenden</button>
                                    <button class="button button--trans" routerLink="/organisation/aerzte-ohne-grenzen">Über
                                        Ärzte ohne Grenzen</button>
                                </div>
                            </div>
                        </div>


                        <div class="col-12 col-lg-4">
                            <div class="card">
                                <div class="card__image">
                                    <img class="img-fluid mw-80 w-uni" src="/assets/unicef.png" />
                                </div>
                                <div>
                                    <button class="button"
                                        *ngIf="firebaseService.voucherValid && firebaseService.voucherUsed === false"
                                        (click)="donate(DonationTarget.unicef)">Spenden</button>
                                    <button class="button button--trans" routerLink="/organisation/unicef">Über
                                        UNICEF</button>
                                </div>
                            </div>
                        </div>

                        <div class="col-12 col-lg-4">
                            <div class="card">
                                <div class="card__image">
                                    <img class="img-fluid max-9 mw-80 w-ft" src="/assets/frankfurter-tafel.png" />
                                </div>
                                <div>
                                    <button class="button"
                                        *ngIf="firebaseService.voucherValid && firebaseService.voucherUsed === false"
                                        (click)="donate(DonationTarget.frankfurterTafel)">Spenden</button>
                                    <button class="button button--trans" routerLink="/organisation/frankfurter-tafel">Über
                                        Frankfurter Tafel</button>
                                </div>
                            </div>
                        </div>


                    </div>

                </section>
            </div>
            <div class="col-12">
                <app-footer></app-footer>
            </div>
        </div>
    </div>

  </div>
</div>

